import { PLAYER, WAVES } from "../config";

export type ShipType = "VOYAGER" | "DEFIANT";

export interface GameData {
  selectedShip: ShipType;
  score: number;
  health: number;
  waveNumber: number;
  borgCount: number;
  invulnerable: boolean;
}

export class GameStore {
  private data: GameData;

  constructor() {
    this.data = this.getInitialData();
  }

  private getInitialData(): GameData {
    return {
      selectedShip: "DEFIANT",
      score: 0,
      health: PLAYER.MAX_HEALTH,
      waveNumber: 1,
      borgCount: WAVES.INITIAL_BORG_COUNT,
      invulnerable: false,
    };
  }

  get selectedShip(): ShipType {
    return this.data.selectedShip;
  }

  setSelectedShip(ship: ShipType): void {
    this.data.selectedShip = ship;
  }

  reset(): void {
    const currentShip = this.data.selectedShip;
    this.data = this.getInitialData();
    this.data.selectedShip = currentShip;
  }

  get score(): number {
    return this.data.score;
  }

  addScore(points: number): void {
    this.data.score += points;
  }

  get health(): number {
    return this.data.health;
  }

  takeDamage(damage: number): void {
    this.data.health = Math.max(0, this.data.health - damage);
  }

  heal(amount: number): void {
    this.data.health = Math.min(PLAYER.MAX_HEALTH, this.data.health + amount);
  }

  get isAlive(): boolean {
    return this.data.health > 0;
  }

  get waveNumber(): number {
    return this.data.waveNumber;
  }

  get borgCount(): number {
    return this.data.borgCount;
  }

  nextWave(): void {
    this.data.waveNumber++;
    this.data.borgCount = Math.min(
      this.data.borgCount + 1,
      WAVES.MAX_BORG_COUNT,
    );
  }

  get invulnerable(): boolean {
    return this.data.invulnerable;
  }

  setInvulnerable(value: boolean): void {
    this.data.invulnerable = value;
  }

  getData(): Readonly<GameData> {
    return this.data;
  }
}

// Singleton instance
export const gameStore = new GameStore();
